<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('deposit.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('deposit.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="ts-flex">
            <div class="ts-w-64">
              <ts-input
                v-model="search"
                :placeholder="$t('deposit.search')"
                style="width: 250px;"
                class="inline-block"
              />
            </div>
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer filter date -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="visible = false"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
      >
        <template v-slot="{ record }">
          <td>{{ record.tran_no }}</td>
          <td>{{ record.supper_dealer.dealer_name }}</td>
          <td>{{ record.tran_date }}</td>
          <td>{{ record.transaction_type.tran_type }}</td>
          <td>
            <span
              :class="
                record.beginning_balance < 0
                  ? 'ts-text-red-600'
                  : 'ts-text-green-600'
              "
              class="ts-font-extrabold"
            >
              {{ number_form(record.beginning_balance) }}
            </span>
          </td>
          <td>
            <span
              :class="
                record.amount < 0 ? 'ts-text-red-600' : 'ts-text-green-600'
              "
              class="ts-font-extrabold"
            >
              {{ number_form(record.amount) }}
            </span>
          </td>
          <td>{{ record.commission_rate }}</td>
          <td>
            <span
              :class="
                record.ending_balance < 0
                  ? 'ts-text-red-600'
                  : 'ts-text-green-600'
              "
              class="ts-font-extrabold"
            >
              {{ number_form(record.ending_balance) }}
            </span>
          </td>
          <td>
            {{ record.user.name }}
          </td>
        </template>
        <template v-slot:tfooter>
          <tr>
            <td colspan="5" class="ts-text-right ts-font-semibold ts-text-blue-600"> <strong>{{ $t('deposit.total') }}</strong> </td>
            <td colspan="4">{{ sum }}</td>
          </tr>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- form create -->
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="$t('deposit.companyDeposit')"
      :zIndex="1020"
      :footer="null"
      :maskClosable="false"
    >
      <FormCreate @cancel="onCancel" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import FormCreate from './components/form'
import moment from 'moment'

export default {
  name: 'companyDeposit',
  components: {
    FormCreate
  },
  data() {
    return {
      loading: false,
      visible: false,
      show_form: false,
      rangeDate: [moment().add(-1, 'Day'), moment()]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('accounting/companyDeposit', ['resources', 'pagination']),
    number_form: () => value => {
      return parseFloat(value).toFixed(2)
    },
    sum(){
      return parseFloat(_.sumBy(this.resources, (o) =>{
        return o.amount;
      })).toFixed(2)
    },
    search: {
      get() {
        return this.$store.state.accounting.companyDeposit.search
      },
      set(newValue) {
        this.$store.commit('accounting/companyDeposit/SET_SEARCH', newValue)
        this.$store.commit('accounting/companyDeposit/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('deposit.tranNo') },
        { name: this.$t('deposit.dealerName') },
        { name: this.$t('deposit.tranDate') },
        { name: this.$t('deposit.transactionType') },
        { name: this.$t('deposit.beginningBalance') },
        { name: this.$t('deposit.amount') },
        { name: this.$t('deposit.commissionRate') },
        { name: this.$t('deposit.endingBalance') },
        { name: this.$t('deposit.createdBy') }
        // { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('accounting/companyDeposit/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.show_form = true
    },
    onCancel() {
      this.show_form = false
      this.fetchData()
    },
    edit(record) {},
    deleteRecord(record) {},
    dateRangeChange(dateRange) {
      this.$store.commit(
        'accounting/companyDeposit/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'accounting/companyDeposit/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
